export default __webpack_public_path__ + "static/media/logo.729df1a1.svg";